/**
 * @flow
 * @relayHash 38c280d7e55c6c7e5ceaffcc0a9b20e3
 */

/* eslint-disable */

'use strict';

/*::
import type { ConcreteRequest } from 'relay-runtime';
export type DeleteHtmlTemplateMutationVariables = {|
  id: string
|};
export type DeleteHtmlTemplateMutationResponse = {|
  +deleteHtmlTemplate: {|
    +id: string
  |}
|};
export type DeleteHtmlTemplateMutation = {|
  variables: DeleteHtmlTemplateMutationVariables,
  response: DeleteHtmlTemplateMutationResponse,
|};
*/


/*
mutation DeleteHtmlTemplateMutation(
  $id: String!
) {
  deleteHtmlTemplate(id: $id) {
    id
  }
}
*/

const node/*: ConcreteRequest*/ = (function(){
var v0 = [
  {
    "kind": "LocalArgument",
    "name": "id",
    "type": "String!",
    "defaultValue": null
  }
],
v1 = [
  {
    "kind": "LinkedField",
    "alias": null,
    "name": "deleteHtmlTemplate",
    "storageKey": null,
    "args": [
      {
        "kind": "Variable",
        "name": "id",
        "variableName": "id"
      }
    ],
    "concreteType": "HtmlTemplateModel",
    "plural": false,
    "selections": [
      {
        "kind": "ScalarField",
        "alias": null,
        "name": "id",
        "args": null,
        "storageKey": null
      }
    ]
  }
];
return {
  "kind": "Request",
  "fragment": {
    "kind": "Fragment",
    "name": "DeleteHtmlTemplateMutation",
    "type": "Mutation",
    "metadata": null,
    "argumentDefinitions": (v0/*: any*/),
    "selections": (v1/*: any*/)
  },
  "operation": {
    "kind": "Operation",
    "name": "DeleteHtmlTemplateMutation",
    "argumentDefinitions": (v0/*: any*/),
    "selections": (v1/*: any*/)
  },
  "params": {
    "operationKind": "mutation",
    "name": "DeleteHtmlTemplateMutation",
    "id": null,
    "text": "mutation DeleteHtmlTemplateMutation(\n  $id: String!\n) {\n  deleteHtmlTemplate(id: $id) {\n    id\n  }\n}\n",
    "metadata": {}
  }
};
})();
// prettier-ignore
(node/*: any*/).hash = '8cf3d898c51e1ad76b685ff92b591602';
module.exports = node;
